/**
 * Normalizza campi salvati come elenco separato da virgole (diagnosi, patologie, allergie, ecc.).
 * Usare in salvataggio, non a ogni onChange.
 */
export function normalizeCommaSeparatedForSave(raw) {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw
      .map((s) => (typeof s === "string" ? s.trim() : String(s ?? "").trim()))
      .filter(Boolean);
  }
  if (typeof raw === "string") {
    return raw.split(",").map((s) => s.trim()).filter(Boolean);
  }
  return [];
}
